import * as React from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';
import useTimeCountdownToGetTimes from '../../../Hooks/useTimeCountdownToGetTimes';
import { buyNFTsData } from '../../../Shared/ExploreDataFactory';
import TimeAgo from 'timeago-react';
import myProfilePhoto from '../../../assets/images/my_profile.png';
import { AnimatePresence, motion } from "framer-motion"
import data from '@emoji-mart/data';
import { Picker } from 'emoji-mart';

import './BuyNFTDetails.scss'
import useClickOutside from '../../../Hooks/useClickOutside';
import { AudioPlayer } from '../../../Components/AudioPlayer/AudioPlayer';
import { useEffect, useState, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { GIFs } from '../../Home/Posts/GIFs/GIFs';
import WebCamCapture from '../../Home/Posts/WebCam/WebCam';
import { VoiceRecorder } from '../../Home/Posts/VoiceRecorder/VoiceRecorder';
import { useMemo } from 'react';
import { allFollowersPeoplesData } from '../../../Shared/GlobalDataFactory';


export interface IAppProps {
}

export function BuyNFTDetails(props: IAppProps) {
    const { nftID } = useParams()
    // const singleMatchGigData = buyNFTsData.find(data => data.id === JSON.parse(nftID!))
    const [singleNftData, setSingleNftData] = React.useState<any>(buyNFTsData.find(data => data.id === JSON.parse(nftID!)))


    const [optionModalOpen, setOptionModalOpen] = React.useState(false);
    const optionModalRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(optionModalRef, () => setOptionModalOpen(false))

    // ---------------------Report Modal---------------------
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const reportModalRef = useRef(null);
    useClickOutside(reportModalRef, () => setReportModalOpen(false));

    const [reasonDropOpen, setReportDropOpen] = React.useState(false)
    const [reasonText, setReasonText] = React.useState('Select a reason');
    let reasonDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(reasonDropRef, () => setReportDropOpen(false))




    // Share modal-------
    const [nftShareModalOpen, setNftShareModalOpen] = useState(false);
    const nftShareModalRef = useRef(null);
    useClickOutside(nftShareModalRef, () => setNftShareModalOpen(false))

    const [modalPeoplesData, setModalPeoplesData] = useState(allFollowersPeoplesData)

    const handleNFTShareModalSearch = (e: any) => {
        const prevModalPeopleData = [...allFollowersPeoplesData]
        const findMatchPeoples = prevModalPeopleData.filter(data => data.name.toLowerCase().includes(e.target.value.toLowerCase()))

        setModalPeoplesData(findMatchPeoples);
    }




    const [placeABidModalOpen, setPlaceABidModalOpen] = React.useState(false);
    const placeABidModalRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(placeABidModalRef, () => setPlaceABidModalOpen(false))

    const { timerDays,
        timerHours,
        timerMinutes,
        timerSeconds, } = useTimeCountdownToGetTimes(singleNftData?.time)





    // Right Side post Sections---------------------------------------------
    const [commentsShow, setCommentsShow] = React.useState(true)
    const [getSubmitCommentInfo, setGetSubmitCommentInfo] = React.useState(false)


    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle Photo Upload----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    // const [clickedPhUpIndex, setClickedPhUpIndex] = useState(-1)
    const [uploadedFile, setUploadedFile] = useState<any>(null);
    const { getRootProps, getInputProps, fileRejections, acceptedFiles } = useDropzone({
        accept: 'image/*',
        maxFiles: 1,
        multiple: false,
        maxSize: 100000000,
        onDrop: acceptedFiles => {
            const acceptedFileWithPreviewSrc = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))
            setUploadedFile(acceptedFileWithPreviewSrc[0]);

        }
    });

    useEffect(() => {
        const assetsPreviewUnderComment = document.getElementById(`assetsPreviewUnderComment`) as HTMLDivElement;
        if (uploadedFile) {
            assetsPreviewUnderComment.innerHTML = '';
            const img = document.createElement('img')
            img.setAttribute('class', 'w-9 h-auto sm:w-24 sm:h-auto mr-2 mb-3 rounded-lg border border-cusBlueWhite')
            img.setAttribute('src', `${uploadedFile.preview}`)
            assetsPreviewUnderComment?.appendChild(img)
        }
    }, [uploadedFile])





    const autoIncraseHeight = (e: any) => {
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }
    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----Hanlde send comment and comment show----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡

    React.useEffect(() => {
        const comments_box = document.getElementById(`comments_box`)
        comments_box?.scrollTo(0, comments_box.scrollHeight);
    }, [singleNftData, commentsShow, getSubmitCommentInfo])




    // Comment Send and Open the comment box---------------------------
    const [isCommentSubmitCommand, setIsCommentSubmitCommand] = useState(false)
    const handleCommentKeyboardEvent = (e: any) => {
        if (e.keyCode === 13) {
            setIsCommentSubmitCommand(true)
            if (e.shiftKey) {
                setIsCommentSubmitCommand(false)
            }
        }
        else {
            setIsCommentSubmitCommand(false)
        }
    }
    // Send comment-----------------------
    const handleCommentSubmit = (e: any,) => {
        const assetsPreviewUnderComment = document.getElementById(`assetsPreviewUnderComment`) as HTMLDivElement;
        // const commentWriteBox: any = (document.getElementById(`commentWriteBox${index}`) as HTMLDivElement);
        const commentIconsBox = document.getElementById(`commentIconsBox`);
        autoIncraseHeight(e)
        const previousPostData = { ...singleNftData }

        let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
        const dateAr = todayDate[0].split('/').reverse()
        const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
        const time = todayDate[1].split(" ")[0]
        const todayDateAndTime = date + ' ' + time;

        if (e.target.value.length > 0 && e.target.value.replace(/\s/g, "").length) {
            commentIconsBox?.classList.replace('absolute', 'static')

            if (isCommentSubmitCommand && previousPostData.nftPostData) {
                const newComment = {
                    id: previousPostData.nftPostData.comments.length + 1,
                    profLogo: myProfilePhoto,
                    commTitle: e.target.value,
                    commPhoto: uploadedFile?.preview,
                    time: todayDateAndTime,
                }
                previousPostData.nftPostData?.comments.push(newComment)
                setSingleNftData(previousPostData)
                setGetSubmitCommentInfo(!getSubmitCommentInfo)
                setCommentsShow(true)
                e.target.value = '';
                e.target.style.height = "24px";
                commentIconsBox?.classList.replace('static', 'absolute')
                if (uploadedFile) {
                    assetsPreviewUnderComment.innerHTML = '';
                    setUploadedFile(null)
                }
            } else {
                return
            }
        }
        else {
            commentIconsBox?.classList.replace('static', 'absolute')
            setCommentsShow(false)
            e.target.value = '';
            e.target.style.height = "24px";
        }

    }




    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----Hanlde Emoji picker----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const emojiPikcerRefs = useRef(null)
    const [isPickerOpen, setIsPickerOpen] = React.useState(false);
    useClickOutside(emojiPikcerRefs, () => setIsPickerOpen(false))

    // Set Emoji from Emoji to comment box-----------
    const hanldeEmojiSetOnComment = (e: any) => {
        const commentWriteBox: any = (document.getElementById(`commentWriteBox`) as HTMLDivElement);
        const writeBoxCursorIndex = commentWriteBox.value.slice(0, commentWriteBox.selectionStart).length
        // let hex: any = e.native?.codePointAt(0)?.toString(16)
        // let emo = String.fromCodePoint(hex);
        const myOutput = commentWriteBox.value.slice(0, writeBoxCursorIndex) + e.native + commentWriteBox.value.slice(writeBoxCursorIndex, commentWriteBox.value.length)
        commentWriteBox.value = myOutput;

        commentWriteBox.selectionEnd = commentWriteBox.selectionStart = writeBoxCursorIndex + e.native.length;
        commentWriteBox.focus();
    }

    // Show Emoji Picker----------------------
    const pickerRef = React.useRef(null)
    const hanldeMyEmojiPicker = (props: any) => {
        return (
            new Picker({
                ...props, data, ref: pickerRef, emojiButtonRadius: '60px',
                // set: 'apple',
                // theme: localStorage.theme ? "dark" : "light",
                previewPosition: 'none',
                emojiButtonColors: [
                    'rgba(155,223,88,.7)',
                    'rgba(149,211,254,.7)',
                    'rgba(247,233,34,.7)',
                    'rgba(238,166,252,.7)',
                    'rgba(255,213,143,.7)',
                    'rgba(211,209,255,.7)',
                ],
            })
        )
    }
    useEffect(() => {
        let emojiPicker: any = document.getElementById(`emojiPicker`)
        if (emojiPicker) {
            if (isPickerOpen) {
                const newEl = hanldeMyEmojiPicker({ onEmojiSelect: (e: any) => hanldeEmojiSetOnComment(e) })
                emojiPicker.appendChild(newEl)
            }
            else {
                emojiPicker.innerHTML = '';
            }
        }
    }, [isPickerOpen])





    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle WebCam----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const [isWebcamOpen, setIsWebcamOpen] = useState(false)
    const [webCamImage, setWebCamImage] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false)

    const webCamModalRef = React.useRef(null)
    useClickOutside(webCamModalRef, () => setIsWebcamOpen(false))


    const [uploadingPercentage, setUploadingPercentage] = useState(0)
    const hanldeWebCamPhotoSubmit = (src: any) => {
        const assetsPreviewUnderComment = document.getElementById(`assetsPreviewUnderComment`)
        setIsSubmitted(true)
        setWebCamImage(src)


        setTimeout(() => {
            setUploadingPercentage(100)
        }, 400)


        setTimeout(() => {
            const previousPostData = { ...singleNftData }
            let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
            const dateAr = todayDate[0].split('/').reverse()
            const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
            const time = todayDate[1].split(" ")[0]
            const todayDateAndTime = date + ' ' + time;


            const newComment = {
                id: previousPostData.nftPostData.comments.length + 1,
                profLogo: myProfilePhoto,
                commPhoto: src,
                time: todayDateAndTime,
            }
            previousPostData.nftPostData.comments.push(newComment)
            setSingleNftData(previousPostData)
            setGetSubmitCommentInfo(!getSubmitCommentInfo)
            setIsSubmitted(false)
            setIsWebcamOpen(false)
            setCommentsShow(true)
            setUploadingPercentage(0)
        }, 1500)

    }

    useEffect(() => {
        isWebcamOpen && setWebCamImage({})
    }, [isWebcamOpen])





    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle GIFs----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const gifBoxsRefs = React.useRef(null)
    // const [clickedGIFBoxIndex, setClickedGIFBoxIndex] = useState({ index: -1, postId: -1, })
    const [isGIFBoxOpen, setIsGIFBoxOpen] = React.useState(false);
    useClickOutside(gifBoxsRefs, () => setIsGIFBoxOpen(false))

    const handleGifOnClick = (data: any) => {
        const previousPostData = { ...singleNftData }
        let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
        const dateAr = todayDate[0].split('/').reverse()
        const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
        const time = todayDate[1].split(" ")[0]
        const todayDateAndTime = date + ' ' + time;

        const newComment = {
            id: previousPostData.nftPostData.comments.length + 1,
            profLogo: myProfilePhoto,
            commPhoto: data.images.preview_gif.url,
            time: todayDateAndTime,
        }
        previousPostData.nftPostData.comments.push(newComment)
        setSingleNftData(previousPostData)
        setCommentsShow(true)
        setGetSubmitCommentInfo(!getSubmitCommentInfo)

    }








    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle Voice Record----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const [isRecorderOpen, setIsRecorderOpen] = useState(false)
    // const [recordedData, setRecordedData] = useState({});
    // const [isRecorderSubmited, setIsRecorderSubmited] = useState(false)

    const recorderModalRef = React.useRef(null)
    useClickOutside(recorderModalRef, () => setIsRecorderOpen(false))


    const hanldeVoiceSubmit = (voiceData: any) => {
        const previousPostData = { ...singleNftData }
        let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
        const dateAr = todayDate[0].split('/').reverse()
        const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
        const time = todayDate[1].split(" ")[0]
        const todayDateAndTime = date + ' ' + time;

        const newComment = {
            id: previousPostData.nftPostData.comments.length + 1,
            profLogo: myProfilePhoto,
            commAudio: voiceData.url,
            time: todayDateAndTime,
        }
        previousPostData.nftPostData.comments.push(newComment)
        setSingleNftData(previousPostData)
        setGetSubmitCommentInfo(!getSubmitCommentInfo)
        setIsRecorderOpen(false)
        setCommentsShow(true)
    }


    const setAudioPlayer = (src: any) => {
        const plyrProps: any = {
            source: {
                type: 'audio',
                title: 'Example title',
                sources: [
                    {
                        src: src,
                        type: 'audio/mp3',
                        size: 720,
                        provider: 'html5',

                    },
                ],
            },
            options: {
                enabled: true,
                debug: false,
                loadSprite: true,
                tooltips: { controls: false, seek: true },

            },
        }

        return (
            plyrProps
        )
    }




    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle Loves----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const handleLoveBtnClick = () => {
        const previousPostData = { ...singleNftData }

        if (previousPostData.nftPostData.isMyloves) {
            previousPostData.nftPostData!.loves = previousPostData.nftPostData!.loves - 1
            previousPostData.nftPostData.isMyloves = false;
            setSingleNftData(previousPostData)
        }
        else {
            previousPostData.nftPostData!.loves = previousPostData.nftPostData!.loves + 1
            previousPostData.nftPostData.isMyloves = true;
            setSingleNftData(previousPostData)
        }
    }




    // Share modal-------
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const shareModalRef = useRef(null);
    useClickOutside(shareModalRef, () => setShareModalOpen(false))

    const [nftPostmodalPeoplesData, setNftPostModalPeoplesData] = useState(allFollowersPeoplesData)

    const handleShareModalSearch = (e: any) => {
        const prevModalPeopleData = [...allFollowersPeoplesData]
        const findMatchPeoples = prevModalPeopleData.filter(data => data.name.toLowerCase().includes(e.target.value.toLowerCase()))

        setNftPostModalPeoplesData(findMatchPeoples);
    }

    const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
    const abbreviateNumber = (number: any) => {
        const tier = Math.log10(Math.abs(number)) / 3 | 0;
        if (tier === 0) return number;
        const suffix = SI_SYMBOL[tier];
        const scale = Math.pow(10, tier * 3);
        const scaled = number / scale;
        return scaled.toFixed(1) + suffix;
    }





    const smallNavItemStyles = 'xs:text-xs sm:text-base font-bold xs:px-2 sm:px-4 small_nav_item pb-4';
    return (
        <div className="bid_details_main_box mx-auto xs:mt-4 sm:mt-10 md:mt-16 mb-16 xs:px-5 pb-48 sm:pb-56 md:pb-0
        pt-[64px]
        max-w-[480px]
        sm:pt-[80px] sm:max-w-[500px]
        md:max-w-[660px]
        lg:max-w-[870px]
        xl:max-w-[1100px]
        2xl:max-w-[1336px]
        3xl:max-w-[1436px]
        ">
            <div className="flex xl:flex-row flex-col justify-center items-start ">



                <div className="xl:order-1 xs:order-2 flex-1">
                    <div className="flex justify-between items-start">
                        <h1 className="text-base xsm:text-xl xl:text-3xl mr-3 font-bold text-cusBlack dark:text-white text-left">{singleNftData?.title}</h1>

                        <div className="flex justify-end items-center space-x-2">
                            <div className="relative">
                                <button
                                    onClick={() => setNftShareModalOpen(!nftShareModalOpen)}
                                    className="flex justify-center items-center
                                   relative filter drop-shadow-md global_icons_only_hover
                                    h-[36px] w-[36px]
                                    lg:w-[40px] lg:h-[40px]
                                    xl:w-[45px] xl:h-[45px]
                                    2xl:w-[52px] 2xl:h-[52px]
                                    ">
                                    <svg className="w-full h-full absolute inset-0 z-[-1] 
                                    fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                        viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px] lg:w-[20px] lg:h-[20px]" width="24.476" height="24.475" viewBox="0 0 24.476 24.475">
                                        <path id="Union_10" data-name="Union 10" d="M10136.334,14296.156a4.8,4.8,0,0,1,.262-1.57l-6.182-3.3a4.822,4.822,0,1,1,.015-5.075l6.177-3.294a4.828,4.828,0,1,1,.706,1.313l-6.306,3.363a4.849,4.849,0,0,1-.007,2.314l6.3,3.358a4.82,4.82,0,1,1-.961,2.888Z" transform="translate(-10121.501 -14276.502)" fill="#3f2063" />
                                    </svg>
                                </button>

                                {/* NFT Share Modal */}
                                <AnimatePresence>
                                    {nftShareModalOpen &&
                                        <div
                                            className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                                            <div className="flex items-center justify-center min-h-screen text-center sm:block sm:p-0">
                                                <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                                <motion.div
                                                    animate={nftShareModalOpen ? "open" : "closed"}
                                                    initial={{ scale: 0.7 }}
                                                    variants={{
                                                        open: { scale: 1 },
                                                        closed: { scale: 0.9 },
                                                    }}
                                                    exit={{ scale: 0 }}
                                                    transition={{ duration: 0.1 }}
                                                    ref={nftShareModalRef}
                                                    className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left overflow-hidden transform transition-all sm:align-middle
                                                 w-11/12 xsm:max-w-sm md:max-w-sm xl:max-w-md xsm:w-full">


                                                    <div className="flex justify-between items-center px-6 pt-5">
                                                        <h5 className="text-cusBlack dark:text-white text-xl font-extrabold dark:font-bold">Share</h5>

                                                        <button onClick={() => setNftShareModalOpen(false)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                                <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                                <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <div className="border-b border-[#dedede] dark:border-[#473a94] mt-2"></div>

                                                    <div className="px-6 py-3 flex justify-start items-center">
                                                        <p className="text-cusBlack dark:text-white font-bold">To:</p>
                                                        <input type="text" name="" id=""
                                                            onChange={handleNFTShareModalSearch}
                                                            placeholder="Search..."
                                                            className="bg-transparent outline-none w-full ml-2 text-cusBlack dark:text-white"
                                                        />
                                                    </div>

                                                    <div className="border-b border-[#dedede] dark:border-[#473a94] "></div>

                                                    <div className="pl-6 pt-3">
                                                        <p className="text-cusBlack dark:text-white font-bold text-sm">Suggested</p>

                                                        <div className="flex flex-col pb-2 h-[200px] sm:h-[300px] xl:h-[320px] overflow-auto mt-2">
                                                            {modalPeoplesData.map((people, index) =>
                                                                <label htmlFor={`shareToPeople${index}`} key={people.id}>
                                                                    <div className="flex justify-between items-center 
                                                                    hover:bg-[#00000010] dark:hover:bg-[#00000020] pl-3 py-[7px] pr-7 rounded-l-lg">
                                                                        <div className="flex justify-start items-center">
                                                                            <div className="
                                                                            w-[40px] h-[40px]
                                                                            md:w-[50px] md:h-[50px] rounded-full overflow-hidden">
                                                                                <div>
                                                                                    <img src={people.photo} alt="" className="w-full h-full" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="text-left ml-3">
                                                                                <h5 className="text-cusBlack dark:text-white text-sm lg:text-base
                                                                                    max-w-[100px] xxsm:max-w-[120px] sm:max-w-[160px] truncate">{people.name}</h5>
                                                                            </div>
                                                                        </div>

                                                                        <div className="">
                                                                            <input type="checkbox"
                                                                                name="shareToPeopleCheckbox" id={`shareToPeople${index}`}
                                                                                className="bg-transparent cursor-pointer border-2 dark:border-[#ff0091]
                                                                                dark:checked:bg-[#ff0091] checked:bg-[#2563eb] dark:focus:outline-pink-600
                                                                                w-4 h-4 md:w-5 md:h-5 focus:outline-none rounded-full form-checkbox transition-all" />
                                                                        </div>
                                                                    </div>

                                                                </label>
                                                            )}
                                                        </div>
                                                    </div>


                                                    <div className="px-6 py-3 xl:py-4">
                                                        <button className="w-full py-2 gradientBG text-white font-bold rounded-md
                                                                hover:tracking-wider transition-all duration-300">
                                                            Send
                                                        </button>

                                                        <button className="w-full py-2 flex justify-center items-center mt-3 border-2 border-[#c5c5c5] dark:border-[#8481c5]
                                                        rounded-lg group">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 md:w-6 stroke-l-LightBlack dark:stroke-cusBlueWhite" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                                                            </svg>
                                                            <p className="text-l-LightBlack dark:text-cusBlueWhite ml-1 font-semibold 
                                                            group-hover:tracking-wider transition-all duration-300 select-none text-sm md:text-base
                                                            ">Copy Link</p>
                                                        </button>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </div>
                                    }
                                </AnimatePresence>
                            </div>






                            <div className="relative">
                                <button
                                    onClick={() => setOptionModalOpen(!optionModalOpen)}
                                    className="flex justify-center items-center
                                   relative filter drop-shadow-md global_icons_only_hover
                                    h-[36px] w-[36px]
                                    lg:w-[40px] lg:h-[40px]
                                    xl:w-[45px] xl:h-[45px]
                                    2xl:w-[52px] 2xl:h-[52px]
                                    ">
                                    <svg className="w-full h-full absolute inset-0 z-[-1] 
                                    fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                        viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px] lg:w-[20px] lg:h-[20px]

                                    " viewBox="0 0 4 16">
                                        <path id="Combined_Shape" data-name="Combined Shape" d="M12,2a2,2,0,1,1,2,2A2,2,0,0,1,12,2ZM6,2A2,2,0,1,1,8,4,2,2,0,0,1,6,2ZM0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z" transform="translate(0 16) rotate(-90)" fill="#fff" />
                                    </svg>
                                </button>
                                <AnimatePresence>
                                    {optionModalOpen &&
                                        <motion.div
                                            initial={{ height: 0, width: 0 }}
                                            animate={{ height: "auto", width: 'auto' }}
                                            exit={{ height: 0, width: 0 }}
                                            transition={{ duration: 0.3 }}
                                            ref={optionModalRef} className="absolute right-0 top-16 w-44 bg-white shadow-lg dark:bg-[#363375] rounded overflow-hidden">
                                            <button className="w-full py-2 hover:bg-gray-200 hover:dark:bg-[#3c379d] rounded-md px-3 flex justify-start items-center"
                                                onClick={() => { setOptionModalOpen(false); setReportModalOpen(!reportModalOpen) }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 blackWhiteSVG" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z" clipRule="evenodd" />
                                                </svg>
                                                <p className="text-l-LightBlack dark:text-white text-lg font-semibold ml-2">Report</p>
                                            </button>
                                        </motion.div>}
                                </AnimatePresence>
                            </div>





                        </div>
                    </div>

                    {/* <h4 className="text-blue-800 font-bold dark:font-normal dark:text-cusLink text-left text-sm sm:text-lg">{singleNftData?.author}</h4> */}

                    <p className="text-l-LightBlack dark:text-cusBlueWhite mt-4 text-sm text-left">{singleNftData?.title} {singleNftData?.discription}</p>

                    <div className="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-y-4 lg:grid-cols-2 justify-start items-center mt-10">
                        <div className="text-left">
                            <p className="text-sm text-cusBlack dark:text-white">Creator <span className="text-black dark:font-medium font-bold dark:text-cusBlueWhite ">{singleNftData?.creator!.royalties}</span></p>
                            <div className="flex justify-start items-center mt-4">
                                <div className="w-12 h-12 rounded-full">
                                    <img src={singleNftData?.creator!.logo} alt="" className="w-full h-full" />
                                </div>
                                <h4 className="text-cusBlack font-bold dark:font-normal dark:text-white ml-4">{singleNftData?.creator!.title}</h4>
                            </div>
                        </div>
                        <div className="text-left">
                            <p className="text-sm font-bold dark:font-normal text-cusBlack dark:text-white">Collection</p>
                            <div className="flex justify-start items-center mt-4">
                                <div className="w-12 h-12 rounded-full">
                                    <img src={singleNftData?.collection!.logo} alt="" className="w-full h-full" />
                                </div>
                                <h4 className="text-cusBlack font-bold dark:font-normal dark:text-white ml-4">{singleNftData?.collection!.name}</h4>
                            </div>
                        </div>

                    </div>



                    <div className=" mt-10">
                        <div className="flex justify-start items-end relative">
                            <NavLink to={`/buyNftDetails/${nftID}/owners`} className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                                Owners
                            </NavLink>
                            <NavLink to={`/buyNftDetails/${nftID}/details`} className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                                Details
                            </NavLink>
                            <NavLink to={`/buyNftDetails/${nftID}/history`} className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                                History
                            </NavLink>
                            <div className="w-full border-2 border-[#DEDEDE] dark:border-[#201753] flex-1 align-bottom"></div>
                        </div>

                        <Outlet />
                    </div>


                    <div className="xs:fixed md:static left-0 w-full z-50 
                     md:mb-0 md:mt-8 lg:mt-16 lightBlueBg xs:p-4 xsm:p-6 md:rounded-md bottom-[79px]">

                        <button
                            onClick={() => setPlaceABidModalOpen(!placeABidModalOpen)}
                            className="gradientBtn w-full xs:py-2 md:py-3 rounded-md text-white">
                            Buy Now
                        </button>
                    </div>





                    <AnimatePresence>
                        {placeABidModalOpen &&
                            <div
                                className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                                <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                    <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                    <motion.div
                                        animate={placeABidModalOpen ? "open" : "closed"}
                                        initial={{ scale: 0.7 }}
                                        variants={{
                                            open: { scale: 1 },
                                            closed: { scale: 0.9 },
                                        }}
                                        exit={{ scale: 0 }}
                                        transition={{ duration: 0.2 }} ref={placeABidModalRef} className="relative inline-block align-bottom p-[5px] listening_modal_gredi_box rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
                                        <div className="bg-[#292757] rounded-xl">
                                            <div className="flex justify-between items-center px-5 pt-3">
                                                <h4 className="xs:text-lg md:text-2xl text-white font-bold">Place a bid</h4>
                                                <button onClick={() => setPlaceABidModalOpen(false)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 md:w-auto" width="21.855" height="21.856" viewBox="0 0 21.855 21.856">
                                                        <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                        <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div className="px-5 pb-7 xs:pt-2 md:pt-5">
                                                <p className="text-white">Price</p>

                                                <div className="bg-[#363375] mt-2 rounded-lg flex justify-between items-center space-x-2">
                                                    <div className="flex justify-start items-center p-3 lg:p-5 border-r border-[#3E3B85]">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10.648" height="17.036" viewBox="0 0 10.648 17.036">
                                                            <g id="Group_1495" data-name="Group 1495" transform="translate(0 0)">
                                                                <g id="Group_1488" data-name="Group 1488" transform="translate(0 0)">
                                                                    <path id="Path" d="M632.2,207.1v6.3l5.323,2.379Z" transform="translate(-626.877 -207.1)" fill="rgba(255,255,255,0.6)" />
                                                                    <path id="Path_1_" d="M466.123,207.1l-5.323,8.676,5.323-2.379Z" transform="translate(-460.8 -207.1)" fill="#fff" />
                                                                    <path id="Path_2_" d="M632.2,521.49v4.279l5.326-7.369Z" transform="translate(-626.877 -508.733)" fill="rgba(255,255,255,0.6)" />
                                                                    <path id="Path_3_" d="M466.123,525.769V521.49L460.8,518.4Z" transform="translate(-460.8 -508.733)" fill="#fff" />
                                                                    <path id="Path_4_" d="M632.2,415.369l5.323-3.09L632.2,409.9Z" transform="translate(-626.877 -403.602)" fill="rgba(255,255,255,0.2)" />
                                                                    <path id="Path_5_" d="M460.8,412.279l5.323,3.09V409.9Z" transform="translate(-460.8 -403.602)" fill="rgba(255,255,255,0.6)" />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                        <p className="font-bold text-white text-xxs xl:text-base whitespace-nowrap ml-2">WETH</p>
                                                    </div>

                                                    <div className="h-full py-3 lg:py-5">
                                                        <input type="number" name="" id="" defaultValue="1.29654"
                                                            className="text-white appearance-none w-full h-full bg-transparent outline-none" />
                                                    </div>

                                                    <div className="flex justify-start items-center p-3 lg:p-5 border-l border-[#3E3B85]">
                                                        <p className="text-white text-xs xl:text-base font-bold">$2,697.84</p>
                                                    </div>
                                                </div>

                                                <p className="text-center w-full text-xxs lg:text-xs my-4 text-cusBlueWhite">Available: 0.0000 WETH</p>


                                                <div className="flex justify-start items-center">
                                                    <input type="checkbox" name="termsOfService" id="termsOfServiceAgree" className="w-5 h-5" />
                                                    <label htmlFor="termsOfServiceAgree">
                                                        <p className="xs:text-xs sm:text-sm text-white ml-2 cursor-pointer">By checking this box, I agree to UNC
                                                            <span className="font-medium text-cusLink"> Terms of Service</span></p>
                                                    </label>
                                                </div>


                                                <button className="text-white xs:mt-5 md:mt-8 w-full xs:py-2.5 md:py-4 rounded-lg gradientBtn">
                                                    Place a bid
                                                </button>
                                            </div>
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        }
                    </AnimatePresence>
                </div>






                <div className="xl:order-2 xs:order-1 xl:ml-8 2xl:ml-28 3xl:ml-36 mb-10
                w-full
                lg:w-[650px]
                xl:w-[550px]
                2xl:w-[650px] 
                ">
                    <div className="connect_single_post lightBlueBg w-full rounded-2xl">

                        <div className="sm:h-[400px] md:h-[480px] lg:h-[500px] xl:h-[460px] 2xl:h-[540px] 3xl:h-[600px] overflow-hidden">
                            <img src={singleNftData?.thumb} alt="" className="w-full h-full" />
                        </div>


                        <div className="xs:mt-1 sm:mt-4 flex justify-between items-start xs:pl-1.5 sm:pl-6 xs:pb-4 sm:pb-5">

                            <div className="flex justify-start items-start flex-1 xs:mt-3 sm:mt-0">
                                <button className="xs:w-8 xs:h-6 sm:w-12 sm:h-10 rounded-full">
                                    <img src={singleNftData?.nftPostData?.profilePic} alt="" className="w-full h-full" />
                                </button>


                                <div className="add_comment_box xs:p-1 sm:p-2 rounded-sm xs:ml-1.5 sm:ml-3 xs:mr-2 lg:mr-5 xl:mr-3 
                                                w-full relative h-full">

                                    <div className="flex">
                                        <textarea
                                            name=""
                                            id={`commentWriteBox`}
                                            onChange={(e) => handleCommentSubmit(e)}
                                            onKeyDown={(e) => handleCommentKeyboardEvent(e)}

                                            placeholder='Add comment'
                                            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                                            className="text-cusBlack dark:text-white bg-transparent outline-none
                                            appearance-none w-full resize-none h-4 sm:h-6 max-h-[200px] overflow-auto xs:text-xxs sm:text-base"
                                        />
                                    </div>



                                    <div className="hidden md:flex justify-end pt-0 items-center space-x-4 bottom-2.5 right-3 absolute"
                                        id={`commentIconsBox`}>

                                        <div className="flex justify-end items-center xs:space-x-4 sm:space-x-2 lg:space-x-4 xl:space-x-2 2xl:space-x-3 3xl:space-x-4">
                                            <button className="relative mt-0.5 m-0 p-0 h-fit w-fit"
                                                ref={emojiPikcerRefs}>
                                                <div className="absolute bottom-7 right-0" id={`emojiPicker`}>

                                                </div>
                                                <div id="" className="cursor-pointer mb-0" onClick={(e) => setIsPickerOpen(!isPickerOpen)} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20">
                                                        <g id="Smile" transform="translate(0.349)">
                                                            <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,1.22A8.806,8.806,0,1,0,16.2,3.8,8.79,8.79,0,0,0,10,1.22Z" transform="translate(-0.349)" fill="" />
                                                            <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval" cx="0.976" cy="0.976" r="0.976" transform="translate(5.082 6.512)" fill="" />
                                                            <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval-2" data-name="Oval" cx="0.976" cy="0.976" r="0.976" transform="translate(12.691 6.512)" fill="" />
                                                            <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape-2" data-name="Shape" d="M5.789,5.61A6.044,6.044,0,0,1,.032,1.317,1.078,1.078,0,0,1,.2.415,1.023,1.023,0,0,1,1.032,0h9.512a1.054,1.054,0,0,1,.8.415,1,1,0,0,1,.171.9A5.983,5.983,0,0,1,5.789,5.61Zm0-2.2a2.556,2.556,0,0,0-1.707.659,4.569,4.569,0,0,0,1.558.3q.075,0,.15,0A4.956,4.956,0,0,0,7.5,4.049,2.7,2.7,0,0,0,5.789,3.415Zm0-1.22a3.735,3.735,0,0,1,2.8,1.268,4.933,4.933,0,0,0,1.683-2.219H1.326A4.706,4.706,0,0,0,2.983,3.463,3.687,3.687,0,0,1,5.789,2.2Z" transform="translate(4.074 10.732)" fill="" />
                                                        </g>
                                                    </svg>
                                                </div>
                                            </button>
                                            <button className="" onClick={() => setIsWebcamOpen(!isWebcamOpen)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 22.744 20.641">
                                                    <g id="Photo" transform="translate(0.5 0.5)">
                                                        <circle className="stroke-[#A6A6A7] dark:stroke-[#6f6dab]" id="Oval" cx="4.41" cy="4.41" r="4.41" transform="translate(6.462 6.41)" fill="none" stroke="" strokeMiterlimit={10} strokeWidth={1} />
                                                        <path className="stroke-[#A6A6A7] dark:stroke-[#6f6dab]" id="Shape" d="M18.436,19.641H3.307A3.311,3.311,0,0,1,0,16.333V6.026A3.311,3.311,0,0,1,3.307,2.718h1a1.856,1.856,0,0,0,1.334-.564L7,.743A2.3,2.3,0,0,1,8.718,0H12.9A2.334,2.334,0,0,1,14.59.718L16.025,2.18a1.89,1.89,0,0,0,1.308.538h1.1a3.312,3.312,0,0,1,3.308,3.308V16.333A3.312,3.312,0,0,1,18.436,19.641Zm-7.564-14.9a6.077,6.077,0,1,0,6.077,6.077A6.084,6.084,0,0,0,10.872,4.744ZM18.23,4.8a1.256,1.256,0,1,0,1.256,1.256A1.258,1.258,0,0,0,18.23,4.8Z" transform="translate(0 0)" fill="none" stroke="" strokeMiterlimit={10} strokeWidth={1} />
                                                    </g>
                                                </svg>
                                            </button>
                                            <div className="relative" ref={gifBoxsRefs}>

                                                <AnimatePresence>
                                                    {isGIFBoxOpen &&
                                                        <motion.div
                                                            initial={{ height: 0, width: 0 }}
                                                            animate={{ height: '', width: '' }}
                                                            exit={{ height: 0, width: 0, opacity: 0 }}
                                                            transition={{ duration: 0.3 }}
                                                            className="absolute bottom-7 right-0 w-72 h-[400px] overflow-hidden">
                                                            <GIFs handleGifOnClick={handleGifOnClick} />
                                                        </motion.div>
                                                    }
                                                </AnimatePresence>


                                                <div id="" className="cursor-pointer mb-0" onClick={() => setIsGIFBoxOpen(!isGIFBoxOpen)}>
                                                    <svg id="GIF" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20.697 19.697">
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M14.233,19.7H6.465A6.472,6.472,0,0,1,0,13.233V6.465A6.472,6.472,0,0,1,6.465,0h7.768A6.472,6.472,0,0,1,20.7,6.465v6.768A6.472,6.472,0,0,1,14.233,19.7ZM6.465,1.163a5.308,5.308,0,0,0-5.3,5.3v6.791a5.308,5.308,0,0,0,5.3,5.3h7.768a5.308,5.308,0,0,0,5.3-5.3V6.465a5.308,5.308,0,0,0-5.3-5.3Z" transform="translate(0)" fill="" />
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path" d="M.581,0A.576.576,0,0,0,0,.581V8.3a.576.576,0,0,0,.581.581A.576.576,0,0,0,1.163,8.3V.581A.576.576,0,0,0,.581,0Z" transform="translate(11 5.651)" fill="" />
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path-2" data-name="Path" d="M.581,0A.576.576,0,0,0,0,.581V8.3a.576.576,0,0,0,.581.581A.576.576,0,0,0,1.163,8.3V4.791H4.07a.581.581,0,0,0,0-1.163H1.163V1.163H4.07A.576.576,0,0,0,4.651.581.576.576,0,0,0,4.07,0Z" transform="translate(13.512 5.651)" fill="" />
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path-3" data-name="Path" d="M3.814,1.163A2.483,2.483,0,0,1,5.791,2.256a.581.581,0,0,0,.93-.7A3.593,3.593,0,0,0,3.814,0C1.7,0,0,2,0,4.442S1.721,8.884,3.814,8.884A3.593,3.593,0,0,0,6.721,7.326a.571.571,0,0,0,.116-.349v-2.3a.581.581,0,0,0-1.163,0V6.767a2.39,2.39,0,0,1-1.86.93c-1.465,0-2.651-1.465-2.651-3.279S2.349,1.163,3.814,1.163Z" transform="translate(3 5.651)" fill="" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <button {...getRootProps({ className: 'uploadImageToPost' })}>
                                                <input  {...getInputProps()} type="file" name="" id="" />
                                                {/* onClick={() => setClickedPhUpIndex(index)} */}
                                                <div  >
                                                    <svg id="File" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 21.25 19.595">
                                                        <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval" cx="1.357" cy="1.357" r="1.357" transform="translate(9.054 3.595)" fill="" />
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M12.221,19.595H12.03l-9.619-.666a2.567,2.567,0,0,1-2.4-2.762L.959,2.4A2.638,2.638,0,0,1,3.554,0h.191L13.34.69A2.6,2.6,0,0,1,15.768,3.4l-.547,7.762-.428,6a2.569,2.569,0,0,1-.881,1.786A2.487,2.487,0,0,1,12.221,19.595Zm-8.1-9.214-2.69,2.167-.262,3.69a1.412,1.412,0,0,0,1.309,1.5l9.618.667h.1a1.433,1.433,0,0,0,.929-.334,1.331,1.331,0,0,0,.476-.952l.428-5.738-2.857-3.31-4.31,3.6.619.69a.581.581,0,0,1,.146.426.59.59,0,0,1-.194.408.649.649,0,0,1-.405.143.556.556,0,0,1-.452-.191Zm-.548-9.19A1.407,1.407,0,0,0,2.174,2.5l-.6,8.452L3.864,9.119a.586.586,0,0,1,.365-.127.6.6,0,0,1,.445.2l1.382,1.571L10.84,6.786a.59.59,0,0,1,.377-.137.617.617,0,0,1,.457.208L14.15,9.69,14.6,3.357a1.412,1.412,0,0,0-1.31-1.5L3.673,1.191Z" transform="translate(5.476)" fill="" />
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path" d="M2.483,1.452l2.667-.214A3.888,3.888,0,0,1,5.816,0L2.387.286a2.556,2.556,0,0,0-1.762.9A2.579,2.579,0,0,0,.007,3.071L1.1,16.81a2.556,2.556,0,0,0,.9,1.762,2.582,2.582,0,0,0,1.667.619h.214L5.1,19.1l-.143-.143a4.931,4.931,0,0,1-.643-.976l-.548.048a1.428,1.428,0,0,1-1.524-1.286L1.149,3A1.462,1.462,0,0,1,2.483,1.452Z" transform="translate(0 0.095)" fill="" />
                                                    </svg>
                                                </div>
                                            </button>
                                            <button onClick={() => setIsRecorderOpen(!isRecorderOpen)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 13.535 21">
                                                    <g id="mic" transform="translate(-91)">
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path_1030" data-name="Path 1030" d="M104.535,255H103.3a5.537,5.537,0,0,1-11.074,0H91a6.777,6.777,0,0,0,6.152,6.739v2.571H92.846v1.23h9.844v-1.23H98.383v-2.571A6.777,6.777,0,0,0,104.535,255Z" transform="translate(0 -244.541)" fill="" />
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path_1031" data-name="Path 1031" d="M155.307,14.766a4.312,4.312,0,0,0,4.307-4.307V4.307a4.307,4.307,0,0,0-8.613,0v6.152A4.312,4.312,0,0,0,155.307,14.766Zm0-13.535a3.081,3.081,0,0,1,3.014,2.461h-1.784v1.23h1.846V6.768h-1.846V8h1.846V9.844h-1.846v1.23h1.784a3.076,3.076,0,0,1-6.029,0h1.784V9.844H152.23V8h1.846V6.768H152.23V4.922h1.846V3.691h-1.784A3.081,3.081,0,0,1,155.307,1.23Z" transform="translate(-57.539)" fill="" />
                                                    </g>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mr-4 xs:mt-3 sm:mt-0.5 flex xs:space-x-1.5 sm:space-x-2 lg:space-x-4 xl:space-x-2 2xl:space-x-4 ">
                                <div className="flex items-center">
                                    <button className={`love_btn_box ${singleNftData.nftPostData.isMyloves ? 'active' : ''}`}
                                        onClick={handleLoveBtnClick}>
                                        <div className="cursor-pointer">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-5 sm:w-8 " fill="none" viewBox="0 0 24 24" stroke="#e62ccf" strokeWidth={2}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                            </svg>
                                        </div>
                                    </button>
                                    <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray xs:ml-0.5 sm:ml-1">{abbreviateNumber(singleNftData.nftPostData.loves)}</p>
                                </div>

                                <div className="flex items-center">
                                    <button onClick={() => setCommentsShow(!commentsShow)}>
                                        <svg id="Group_16" className="xs:w-4 sm:w-8 " data-name="Group 16" xmlns="http://www.w3.org/2000/svg" width="23.317" height="22.76" viewBox="0 0 23.317 22.76">
                                            <g id="Group_15" data-name="Group 15">
                                                <path id="Path_3" data-name="Path 3" d="M11.659,0C5.2,0,0,4.581,0,10.22a9.875,9.875,0,0,0,4.323,7.988l.182,3.82c.034.712.524.944,1.094.52L8.744,20.2a11.793,11.793,0,0,0,2.915.294c6.461,0,11.659-4.581,11.659-10.22S18.12,0,11.659,0Z" fill="#6f6dab" />
                                            </g>
                                        </svg>
                                    </button>
                                    <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray xs:ml-0.5 sm:ml-1">{singleNftData.nftPostData.comments.length}</p>
                                </div>

                                <div className="flex items-center">
                                    <button onClick={() => setShareModalOpen(!shareModalOpen)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-4 sm:w-8 " width="27.743" height="22.397" viewBox="0 0 27.743 22.397">
                                            <g id="_09" data-name="09" transform="translate(0 0)">
                                                <g id="Слой_2" data-name="Слой 2" transform="translate(0)">
                                                    <g id="Слой_1" data-name="Слой 1">
                                                        <path id="Path_5" data-name="Path 5" d="M0,21.625a.872.872,0,0,0,.688.771.872.872,0,0,0,.989-.6A14.557,14.557,0,0,1,5.6,16.761a14.842,14.842,0,0,1,9.308-3.354h3.539v3.069a.738.738,0,0,0,.235.52.721.721,0,0,0,.47.184.688.688,0,0,0,.47-.184L27.538,9.08a.7.7,0,0,0,0-.989L19.639.209A.7.7,0,0,0,18.449.7V3.764H17.023A17.24,17.24,0,0,0,3.607,10.472,18.079,18.079,0,0,0,0,21.625Z" transform="translate(0.002 -0.014)" fill="#6f6dab" />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                    <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray xs:ml-0.5 sm:ml-1">{singleNftData.nftPostData.shares}</p>
                                </div>
                            </div>
                        </div>


                        {/* Photo, Voice Record, Gig Preview section */}
                        <div className="flex justify-between items-start xs:pl-1.5 sm:pl-6">
                            <div className="flex justify-start items-start">
                                <div className="ml-2 sm:ml-3 flex flex-wrap w-full" id={`assetsPreviewUnderComment`}>

                                </div>
                            </div>
                        </div>

                        <AnimatePresence>
                            {commentsShow &&
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    // transition={{ duration: 0.3 }}
                                    className={`${singleNftData.nftPostData.comments.length > 0 ? 'h-56 px-6 py-3' : 'overflow-hidden'} overflow-auto comments_box`} id={`comments_box`}>
                                    {singleNftData.nftPostData?.comments.map((comm: any) =>
                                        <motion.div
                                            initial="hidden"
                                            animate="visible"
                                            variants={{
                                                hidden: { x: -100 },
                                                visible: { x: 0 },
                                            }}

                                            transition={{ duration: 0.5 }}
                                            className="flex justify-start items-start mb-4" key={comm.id}>
                                            <div className="xs:w-8 sm:w-10 xs:h-8 sm:h-10 rounded-full">
                                                <img src={comm.profLogo} alt="" className="xs:w-8 sm:w-10 xs:h-8 sm:h-10 " />
                                            </div>

                                            <div className="ml-5 text-left flex-1">
                                                {comm.commTitle &&
                                                    <p className="xs:text-xs sm:text-sm xl:text-base pt-1.5 sm:py-1.5 text-cusBlack dark:text-white break-all"
                                                        style={{ whiteSpace: 'pre-line', }}>{comm.commTitle}</p>
                                                }
                                                {comm.commPhoto &&
                                                    <div className={`w-20 sm:w-36 h-auto rounded-md mt-0.5 overflow-hidden hover:opacity-60 cursor-pointer`}>
                                                        <img src={comm.commPhoto} className="w-full h-full" alt="" />
                                                    </div>
                                                }
                                                {comm.commAudio &&
                                                    comm.commAudio.length > 0 &&
                                                    <AudioPlayer audioPlyrProps={setAudioPlayer(comm.commAudio)} />
                                                }
                                                <TimeAgo
                                                    className="text-cusBlack dark:text-cusBlueWhite text-xxs sm:text-xs"
                                                    datetime={comm.time}
                                                    locale='en_US'
                                                />
                                            </div>
                                        </motion.div>
                                    )}
                                </motion.div>}
                        </AnimatePresence>

                    </div>






                    {/* Voice Recorder Modal */}
                    <AnimatePresence>
                        {isRecorderOpen &&
                            <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                                <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                    <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                    <motion.div
                                        animate={isRecorderOpen ? "open" : "closed"}
                                        initial={{ scale: 0.7 }}
                                        variants={{
                                            open: { scale: 1 },
                                            closed: { scale: 0.9 },
                                        }}
                                        exit={{ scale: 0 }}
                                        transition={{ duration: 0.1 }}
                                        ref={recorderModalRef}
                                        className="relative inline-block align-bottom bg-white dark:bg-[#292757] rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle
                                    sm:max-w-md lg:max-w-xl sm:w-full">
                                        <div className="text-right pr-6 pt-5">
                                            <button onClick={() => setIsRecorderOpen(false)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                    <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                    <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                </svg>
                                            </button>
                                        </div>

                                        <div className="px-4 pt-1 pb-10 text-center">
                                            <VoiceRecorder hanldeVoiceSubmit={hanldeVoiceSubmit} />
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        }
                    </AnimatePresence>


                    {/* WebCam Modal */}
                    <AnimatePresence>
                        {isWebcamOpen &&
                            <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                                <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                    <div className="fixed inset-0 bg-gray-900 transition-all bg-opacity-75" aria-hidden="true" />
                                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                    <motion.div
                                        animate={isWebcamOpen ? "open" : "closed"}
                                        initial={{ scale: 0.7 }}
                                        variants={{
                                            open: { scale: 1 },
                                            closed: { scale: 0.9 },
                                        }}
                                        exit={{ scale: 0, x: -100 }}
                                        transition={{ duration: 0.1 }}
                                        ref={webCamModalRef}
                                        className="relative inline-block align-bottom bg-white dark:bg-[#292757] rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle
                                    sm:max-w-md lg:max-w-xl sm:w-full">
                                        <div className="text-right pr-6 pt-5">
                                            <button onClick={() => setIsWebcamOpen(false)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                    <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                    <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                </svg>
                                            </button>
                                        </div>

                                        <div className="px-4 pt-1 pb-10 text-center">
                                            {isSubmitted
                                                ? <div className="shadow w-full mt-6 mb-3 bg-gray-200 rounded-full overflow-hidden">
                                                    <div className="gradientBtn text-xs leading-none py-1 text-center rounded-full transition-all text-white"
                                                        style={{ width: `${uploadingPercentage}%` }}>{`${uploadingPercentage}%`}</div>
                                                </div>

                                                : <div className="mx-auto w-80 p-3 bg-cusGray dark:bg-[#292757] shadow-xl  dark:shadow-[#1e1c3c]">
                                                    <WebCamCapture hanldeWebCamPhotoSubmit={hanldeWebCamPhotoSubmit} />
                                                </div>
                                            }
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        }
                    </AnimatePresence>


                    {/* Post Share Modal */}
                    <AnimatePresence>
                        {shareModalOpen &&
                            <div
                                className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                                <div className="flex items-center justify-center min-h-screen text-center sm:block sm:p-0">
                                    <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                    <motion.div
                                        animate={shareModalOpen ? "open" : "closed"}
                                        initial={{ scale: 0.7 }}
                                        variants={{
                                            open: { scale: 1 },
                                            closed: { scale: 0.9 },
                                        }}
                                        exit={{ scale: 0 }}
                                        transition={{ duration: 0.1 }}
                                        ref={shareModalRef}
                                        className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left overflow-hidden transform transition-all sm:align-middle
                                                 w-11/12 xsm:max-w-sm md:max-w-sm xl:max-w-md xsm:w-full">

                                        <div className="flex justify-between items-center px-6 pt-5">
                                            <h5 className="text-cusBlack dark:text-white text-xl font-extrabold dark:font-bold">Share</h5>

                                            <button onClick={() => setShareModalOpen(false)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                    <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                    <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                </svg>
                                            </button>
                                        </div>
                                        <div className="border-b border-[#dedede] dark:border-[#473a94] mt-2"></div>

                                        <div className="px-6 py-3 flex justify-start items-center">
                                            <p className="text-cusBlack dark:text-white font-bold">To:</p>
                                            <input type="text" name="" id=""
                                                onChange={handleShareModalSearch}
                                                placeholder="Search..."
                                                className="bg-transparent outline-none w-full ml-2 text-cusBlack dark:text-white"
                                            />
                                        </div>

                                        <div className="border-b border-[#dedede] dark:border-[#473a94] "></div>

                                        <div className="pl-6 pt-3">
                                            <p className="text-cusBlack dark:text-white font-bold text-sm">Suggested</p>

                                            <div className="flex flex-col pb-2 h-[200px] sm:h-[300px] xl:h-[320px] overflow-auto mt-2">
                                                {nftPostmodalPeoplesData.map((people, index) =>
                                                    <label htmlFor={`shareToPeople${index}`} key={people.id}>
                                                        <div className="flex justify-between items-center 
                                                hover:bg-[#00000010] dark:hover:bg-[#00000020] pl-3 py-[7px] pr-7 rounded-l-lg">
                                                            <div className="flex justify-start items-center">
                                                                <div className="
                                                        w-[40px] h-[40px]
                                                        md:w-[50px] md:h-[50px] rounded-full overflow-hidden">
                                                                    <div>
                                                                        <img src={people.photo} alt="" className="w-full h-full" />
                                                                    </div>
                                                                </div>
                                                                <div className="text-left ml-3">
                                                                    <h5 className="text-cusBlack dark:text-white text-sm lg:text-base
                                                            max-w-[100px] xxsm:max-w-[120px] sm:max-w-[160px] truncate">{people.name}</h5>
                                                                </div>
                                                            </div>

                                                            <div className="">
                                                                <input type="checkbox"
                                                                    name="shareToPeopleCheckbox" id={`shareToPeople${index}`}
                                                                    className="bg-transparent cursor-pointer border-2 dark:border-[#ff0091]
                                                            dark:checked:bg-[#ff0091] checked:bg-[#2563eb] dark:focus:outline-pink-600
                                                            w-4 h-4 md:w-5 md:h-5 focus:outline-none rounded-full form-checkbox transition-all" />
                                                            </div>
                                                        </div>

                                                    </label>
                                                )}
                                            </div>
                                        </div>


                                        <div className="px-6 py-3 xl:py-4">
                                            <button className="w-full py-2 gradientBG text-white font-bold rounded-md
                                     hover:tracking-wider transition-all duration-300">
                                                Send
                                            </button>

                                            <button className="w-full py-2 flex justify-center items-center mt-3 border-2 border-[#c5c5c5] dark:border-[#8481c5]
                                rounded-lg group
                                    ">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 md:w-6 stroke-l-LightBlack dark:stroke-cusBlueWhite" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                                                </svg>

                                                <p className="text-l-LightBlack dark:text-cusBlueWhite ml-1 font-semibold 
                                        group-hover:tracking-wider transition-all duration-300 select-none text-sm md:text-base
                                        ">Copy Link</p>
                                            </button>
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        }
                    </AnimatePresence>



                    {/* Report Modal */}
                    <AnimatePresence>
                        {reportModalOpen &&
                            <div
                                className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                                <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                    <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                    <motion.div
                                        animate={reportModalOpen ? "open" : "closed"}
                                        initial={{ scale: 0.7 }}
                                        variants={{
                                            open: { scale: 1 },
                                            closed: { scale: 0.9 },
                                        }}
                                        exit={{ scale: 0 }}
                                        transition={{ duration: 0.1 }}
                                        ref={reportModalRef}
                                        className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left transform transition-all sm:align-middle
                                                  max-w-sm xl:max-w-lg w-full">
                                        <div className="px-6 py-5">
                                            <div className="flex justify-between items-center">
                                                <h5 className="text-cusBlack dark:text-white text-base xxsm:text-xl font-extrabold dark:font-bold">Report this account</h5>

                                                <button onClick={() => setReportModalOpen(false)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                        <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                        <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                    </svg>
                                                </button>
                                            </div>

                                            <div className="my-8">
                                                <p className="text-cusBlack dark:text-white font-semibold inline-block cursor-default text-xs xxsm:text-sm xsm:text-base">I think this account is...</p>

                                                <div
                                                    ref={reasonDropRef}
                                                    className="border-2 border-[#e6e8ec] hover:border-gray-300 dark:hover:border-gray-400
                                            dark:border-[#e6e8ec20] px-3 py-3 rounded-md md:rounded-lg mt-1 transition-all cursor-pointer relative w-full text-left"
                                                    onClick={() => setReportDropOpen(!reasonDropOpen)}>
                                                    <div className="flex justify-between items-center break-all">
                                                        <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm truncate">{reasonText}</h4>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${reasonDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                                        </svg>
                                                    </div>
                                                    <AnimatePresence>
                                                        {reasonDropOpen &&
                                                            <motion.div
                                                                animate={reasonDropOpen ? "open" : "closed"}
                                                                initial={{ y: -15, }}
                                                                variants={{
                                                                    open: { y: 0, },
                                                                    closed: { y: -100, },
                                                                }}
                                                                exit={{ opacity: 0, y: -15 }}
                                                                transition={{ duration: 0.2 }}
                                                                className="rounded-xl overflow-hidden absolute top-10 md:top-12 bg-white dark:bg-[#3b316e] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                                                {[
                                                                    "Fake collection or possible scam",
                                                                    "Explicit and sensitive content",
                                                                    "Spam",
                                                                    "Might be stolen",
                                                                    "Harassment",
                                                                    "False information",
                                                                    "Unauthorized Sales",
                                                                    "Hate Speech",
                                                                    "Terrorism",
                                                                    "Something Else",
                                                                    "Other",
                                                                ].map(item =>
                                                                    <div onClick={() => { setReasonText(item) }}
                                                                        className="py-1.5 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                                        <p className="text-cusBlack dark:text-white text-xs lg:text-sm font-normal truncate">{item}</p>
                                                                    </div>
                                                                )}
                                                            </motion.div>}
                                                    </AnimatePresence>
                                                </div>
                                            </div>


                                            <button
                                                onClick={() => setReportModalOpen(false)}
                                                className="gradientBtn w-full py-3 rounded-lg text-white font-semibold text-xs xxsm:text-sm xsm:text-base">
                                                Report Now
                                            </button>

                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        }
                    </AnimatePresence>






















                </div>

            </div>
        </div>
    );
}
